import { render, staticRenderFns } from "./item1.vue?vue&type=template&id=418d013c&"
import script from "./item1.vue?vue&type=script&lang=js&"
export * from "./item1.vue?vue&type=script&lang=js&"
import style0 from "./item1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports